import { RouterModule, Routes } from '@angular/router';

let routes: Routes = [
  {
    path: '',
    loadChildren: () => import('../pages/imobiliare/imobiliare.module').then((m) => m.ImobiliareModule),
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full',
  },
];

export const AppRouting = RouterModule.forRoot(routes, {
  initialNavigation: 'enabledBlocking'
});
